// Boots the application bundle: initialize every singleton, then run the page
// module for this request. Imported last by application.ts so that everything
// has registered by the time this runs.
import { findCurrentPage, onDomReady, Paratelligent } from "./first"

for (const singleton of Object.values(Paratelligent.singletons)) {
  singleton.initialize?.()
  if (singleton.onDomReady) {
    onDomReady(() => singleton.onDomReady?.())
  }
}

onDomReady(() => {
  const page = findCurrentPage()
  Paratelligent.currentPage = page

  // Admin pages ship in the admin bundle and are run by admin/main instead,
  // so that admin JS only ever runs for admins.
  if (!page || page.isAdminOnly) return

  page.initialize?.()
  page.onDomReady?.()
})
